module.exports = __webpack_public_path__ + "img/bg-footer-title.99f31ff6.svg";